module.exports = __webpack_public_path__ + "static/media/respond.e7f8491f.png";